import ReactDOM from "react-dom";

export function MyModal({ children }) {
  const modalRoot = document.getElementById("modal-root");

  if (!modalRoot) return null;

  return ReactDOM.createPortal(children, modalRoot);
}